<template>
  <Popup
      style="width: 100%;height: 100%;"
      :value="show"
      @click-close-icon="show = false"
      :close-on-click-overlay="false"
      closeable
  >
    <div v-if="show"  @click="show = false" style="height: 100%;width: 100%;background: #000;display: flex;align-items: center;overflow: auto">
      <img style="min-width: 100%" @click="show = false" :src="src" alt="">
    </div>
  </Popup>
</template>

<script>
import {Popup} from 'vant';

export default {
  name: 'ImgPopup',

  data() {
    return {

      show: false,
      src: ""
    }
  },
  methods: {
    openPopup(src) {
      this.src = src
      this.show = true;
    },
    clickConfirm() {
      this.show = false
      this.$emit('ok')
    },
    closePopup() {
      this.show = false
      this.$emit('close')
    },
  },
  components: {Popup}
}
</script>

<style scoped lang="scss">

</style>
